import { render } from "./NoChargedLeadReport.vue?vue&type=template&id=5ed3b2f6"
import script from "./NoChargedLeadReport.vue?vue&type=script&lang=js"
export * from "./NoChargedLeadReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__